import AppBar from '@material-ui/core/AppBar'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Toolbar from '@material-ui/core/Toolbar'
import clsx from 'clsx'
import React from 'react'
import ContainerMaxWidthXl from './ContainerMaxWidthXl'

const useStyles = makeStyles((theme: Theme) => ({
    appBar: (props: DoubleAppToolbarStyleProps) => ({
        height: props.upperBarHeight + props.lowerBarHeight,
        zIndex: theme.zIndex.drawer + 1,
    }),
    upperBar: (props: DoubleAppToolbarStyleProps) => ({
        minHeight: props.upperBarHeight,
        backgroundColor: props.upperBarBackgroundColor,
    }),
}))

export interface DoubleAppToolbarStyleProps {
    /** Upper bar's background color. */
    upperBarBackgroundColor: string
    /** Upper bar's height. */
    upperBarHeight: number
    /** Lower bar's height. */
    lowerBarHeight: number
}

export interface DoubleAppToolbarProps
    extends Partial<DoubleAppToolbarStyleProps> {
    /** The positioning type. The behavior of the different options is described in the MDN web docs. Note: sticky is not universally supported and will fall back to `static` when unavailable. */
    position?: 'fixed' | 'absolute' | 'sticky' | 'static' | 'relative'
    /** Upper bar's children (React Element). */
    UpperChildren?: React.ReactElement
    /** Lower bar must have the height declared here. */
    LowerChildren?: React.ReactElement
}

const DoubleAppToolbar: React.FC<DoubleAppToolbarProps> = ({
    upperBarBackgroundColor = '#043258',
    upperBarHeight = 50,
    lowerBarHeight = 50,
    position = 'fixed',
    UpperChildren,
    LowerChildren,
    ...rest
}) => {
    const classes = useStyles({
        upperBarBackgroundColor,
        upperBarHeight,
        lowerBarHeight,
    })

    return (
        <AppBar className={clsx('doubleAppToolbar', classes.appBar)} {...rest}>
            <Toolbar
                className={clsx('doubleAppToolBarUpper', classes.upperBar)}
            >
                <ContainerMaxWidthXl>{UpperChildren}</ContainerMaxWidthXl>
            </Toolbar>
            {LowerChildren}
        </AppBar>
    )
}

export default DoubleAppToolbar
